import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import * as selectors from '../../selectors';
import NotificationHandler from './NotificationHandler.component';

const mapStateToProps = state => ({
  notifications: selectors.notifications(state),
});

export default withSnackbar(connect(mapStateToProps)(NotificationHandler));
